/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/prefer-default-export */
import api from '@utils/axios';
import { apiInternalActivitiesPath } from '../../../routes';
import { ActivityPageSize, SorterOptions } from '../constants';
export const getActivities = ({ buildingId, inspectionId, workOrderId, deficiencyId, params }) => {
    const { type, sort, page } = params;
    return api.get(apiInternalActivitiesPath({
        building_id: buildingId,
        inspection_id: inspectionId,
        work_order_id: workOrderId,
        deficiency_id: deficiencyId,
        format: 'json',
        filter: type.join(','),
        sort: sort === SorterOptions.OldestToNewest ? 'desc' : 'asc',
        select: {
            page,
            size: ActivityPageSize
        }
    }));
};
